/**
 * Animation style enum matching C++ AnimationStyle values.
 *
 * C++ Reference: tabanim/main/client/MarkAnimationControllerInterface.cpp
 * C# Reference: AnimationUtil.cs ConvertAnimationStyleToInt()
 */
export enum AnimationStyle {
  Synced = 0,
  Phased = 1,
  InheritStyle = 2,
}

const validAnimationStyles = new Set<number>([AnimationStyle.Synced, AnimationStyle.Phased, AnimationStyle.InheritStyle]);

/**
 * Parse an integer from viz-client into an AnimationStyle enum.
 * Falls back to Synced for unknown values.
 */
export function animationStyleFromInt(val: number): AnimationStyle {
  if (validAnimationStyles.has(val)) {
    return val as AnimationStyle;
  }
  return AnimationStyle.Synced;
}
